<div role="contentinfo" class="footer text-white text-center bg-primary">
  <div class="footer-quicklinks w-100 p-1">
    <ng-container *ifScreenSize="screenType.Desktop">
      <div class="d-flex justify-content-center text-white font-size-14 fw-bold">
        <a href="{{ 'hawks.terms.url' | translate }}" target="_blank"> {{ 'hawks.terms.link' | translate }} </a>
        <div class="mx-2">|</div>
        <a href="{{ 'hawks.privacy.url' | translate }}" target="_blank"> {{ 'hawks.privacy.link' | translate }} </a>
        <div class="mx-2">|</div>

        <a href="{{ 'rewards.terms.url' | translate }}" target="_blank"> {{ 'footer.rewards.terms.use' | translate }} </a>
        <div class="mx-2">|</div>
        <a href="{{ 'nav.contact.url' | translate }}" target="_blank"> {{ 'footer.contact.us' | translate }} </a>
      </div>
    </ng-container>

    <ng-container *ifScreenSize="screenType.Mobile">
      <div class="d-flex justify-content-center text-white font-size-14 fw-bold">
        <a href="{{ 'hawks.terms.url' | translate }}" target="_blank"> {{ 'hawks.terms.link' | translate }} </a>
        <div class="mx-1">|</div>
        <a href="{{ 'hawks.privacy.url' | translate }}" target="_blank"> {{ 'hawks.privacy.link' | translate }} </a>
        <div class="mx-1">|</div>
      </div>
      <div class="d-flex justify-content-center text-white font-size-14 fw-bold">
        <a href="{{ 'rewards.terms.url' | translate }}" target="_blank"> {{ 'footer.rewards.terms.use' | translate }} </a>
        <div class="mx-1">|</div>
        <a href="{{ 'nav.contact.url' | translate }}" target="_blank"> {{ 'footer.contact.us' | translate }} </a>
      </div>
    </ng-container>
  </div>
  <div class="footer-text d-flex align-items-center justify-content-center w-100">
    <div class="footer-content">
      <img alt="" class="footer-logo mb-3 mt-lg-0 mt-5" src="assets/images/nav-logo.svg" draggable="false" />

      <div class="font-size-14 footer-rights">{{ 'footer.description' | translate }}</div>
    </div>
  </div>
</div>
